import { Component } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { lastValueFrom } from 'rxjs';
import { Router } from '@angular/router';
import { WsSignInService } from 'src/app/ws/wsSignIn/ws-sign-in.service';
import { MSignUpRequest } from './sign-up.module';

@Component({
  selector: 'app-sign-up',
  templateUrl: './sign-up.component.html',
  styleUrls: ['./sign-up.component.scss']
})
export class SignUpComponent {

  registerFormgroup!: FormGroup;
  verifyOtpFormgroup!: FormGroup;
  phone_number: any;
  mSignUpReq: MSignUpRequest = new MSignUpRequest();
  loaderShow: boolean = false;
  viewForm: any = '';

  get f() {
    return this.registerFormgroup.controls;
  }

  get otpf() {
    return this.verifyOtpFormgroup.controls;
  }
  constructor(private formBuilder: FormBuilder,private router: Router,private wssigninservice: WsSignInService) {
    this.registerFormgroup = this.formBuilder.group({
      phone_number: new FormControl('', [Validators.required, Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$")]),
      first_name:  new FormControl('', [Validators.required]),
      last_name:   new FormControl('', [Validators.required]),
      email: new FormControl(''),
      gender: new FormControl(''),
      birth_date: new FormControl(''),
      type_id: new FormControl(''),
      alternate_mob_no: new FormControl('')
    });
    this.verifyOtpFormgroup = this.formBuilder.group({
      otp: ['', [Validators.required, Validators.pattern("^((\\+91-?)|0)?[0-9]{4}$")]]
    });
  }

  /**
   * On Click Button
  */ 
  async onSubmit(val:any) {
    if (val == 'register') {
      this.viewForm = 'register'
      this.getOtp(); 
    } else if (val == 'verifyOTP') {
      this.viewForm = 'verifyOTP'
      this.verifyOtp();
    } 
     else {
      this.viewForm = ''
    }
  }

    /**
   * for Get OTP
   */
    async getOtp() {
      const getOtp =  this.wssigninservice.getOtp(this.registerFormgroup.controls['phone_number'].value)
      await lastValueFrom(getOtp).then(async response => {
        if (response && response.statusCode == 200) {
        } else {
        }
      })
    }
  
     /**
   * for Verify OTP
   */
     async verifyOtp() {
      const verifyOtp =  this.wssigninservice.getVerifyOtp(this.registerFormgroup.controls['phone_number'].value,this.verifyOtpFormgroup.controls['otp'].value)
      await lastValueFrom(verifyOtp).then(async response => {
        if (response && response.statusCode == 200) {
          this.router.navigate(['/home-page'])
        } else {
          this.registerUser();
        }
      })
    }

     /**
  * for Register User
  */
  async registerUser() {
        this.mSignUpReq.first_name = this.registerFormgroup.controls['first_name'].value
        this.mSignUpReq.last_name = this.registerFormgroup.controls['last_name'].value
        this.mSignUpReq.phone_number = this.registerFormgroup.controls['phone_number'].value
        this.mSignUpReq.email = this.registerFormgroup.controls['email'].value
        this.mSignUpReq.alternate_mob_no = this.registerFormgroup.controls['alternate_mob_no'].value
        this.mSignUpReq.gender = this.registerFormgroup.controls['gender'].value
        this.mSignUpReq.birth_date = this.registerFormgroup.controls['birth_date'].value
        this.mSignUpReq.type_id = 3
        this.mSignUpReq.role_permissions_id = ""
        this.mSignUpReq.password = ""
    
        
        this.loaderShow = true;
        const adduser = this.wssigninservice.addUser(this.mSignUpReq)
        await lastValueFrom(adduser).then(async response => {
          if (response && response.statusCode == 200) {
            this.router.navigate(['/home-page']) 
          } else {
          }
        })
      }
}
